import { render, staticRenderFns } from "./JobFitAnalyzer.vue?vue&type=template&id=6ba09847"
import script from "./JobFitAnalyzer.vue?vue&type=script&lang=js"
export * from "./JobFitAnalyzer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports